import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";

/** Muted verb + arrow between two chips, e.g. "Lisa  looks at →  Player". */
export default function PiConnectorLabel({ text }: { text: string }) {
  return (
    <span className="inline-flex flex-none items-center gap-1.5 text-[13px] text-creator-text-sub whitespace-nowrap">
      {text}
      <ArrowForwardIcon className="text-interaction-primary-faded" sx={{ fontSize: 18 }} />
    </span>
  );
}
